/* eslint-disable import/prefer-default-export */
/**
 * Formats a bill name from snake_case to Title Case
 * e.g., "cleaning_service" → "Cleaning Service"
 * e.g., "wifi" → "Wifi"
 */
export const formatBillName = (name: string): string => {
  if (!name) return "";

  return name
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
